<template>
  <div class='content'>
    <p class='title'>{{ isOwner === true ? '收支费用' : '费用' }}</p>
    <div class='fee-info'>
      <!-- 业主 -->
      <div class='info-item' v-if="isOwner === true">本月支出 {{ info.cost }}</div>
      <div class='info-item' v-if="isOwner === true">本月收入 {{ info.income }}</div>
      <div class='info-item' v-if="isOwner === true">本月利润 {{ info.profit }}</div>
      <!-- 租户 -->
      <div class='info-item' v-if="isOwner === false">本月电费 {{ currentMonthElectricity }}</div>
      <div class='info-item' v-if="isOwner === false">本月水费 {{ currentMonthWaterRates }}</div>
      <div class='info-item' v-if="isOwner === false">本月气费 {{ currentMonthGasFee }}</div>
    </div>
    <div class='chart' ref='chart'>
      <charts-component className='fee-chart' ref='chartsComponent'></charts-component>
    </div>
  </div>
</template>

<script>
import chartsComponent from './chartsComponent'
export default {
  name: 'fee-info',
  components: {
    chartsComponent,
  },
  props: {
    isOwner: {
      type: Boolean,
      default: true
    },
    info: {},
    costList: Array,
    currentMonthElectricity: Number,
    currentMonthGasFee: Number,
    currentMonthWaterRates: Number
  },
  data () {
    return {};
  },
  created () {
    // this.handleChartInit()
  },
  methods: {
    handleChartInit () {
      let time = this.costList.map((item) => {
        return item.time
      })
      let electricity = this.costList.map((item) => {
        return item.electricity
      })
      let gasFee = this.costList.map((item) => {
        return item.gasFee
      })
      let waterRates = this.costList.map((item) => {
        return item.waterRates
      })
      let options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        legend: {
          data: ['电', '气', '水']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: time
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '电',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: electricity
          },
          {
            name: '气',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: gasFee
          },
          {
            name: '水',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: waterRates
          }
        ]
      }
      this.$nextTick(() => {
        try {
          this.$refs.chartsComponent.init(options)
        } catch (error) {
          console.log(error)
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
p {
  margin: 0;
}
.content {
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  color: #333;
  .title {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .fee-info {
    margin: 12px 0;
    width: 100%;
    display: flex;
    .info-item {
      box-sizing: border-box;
      padding: 0 8px;
      background: rgba(245, 155, 91, 0.6);
      width: calc(33.33% - 11px);
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      font-weight: bold;
      &:not(:last-child) {
        margin-right: 16px;
      }
    }
  }
  .chart {
    width: 100%;
    height: calc(100% - 100px);
    // border: 1px solid;
  }
}
</style>
